import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { truncate } from 'lodash';
import { DataStorageService } from 'src/app/core/services/dataStorage/data-storage.service';
import {
	PARAM_LABEL_BENEFICIAIRE,
	PARAM_LABEL_INTERVENANT,
	PARAM_LABEL_INTERVENTION,
	PARAM_LABEL_USER
} from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { User } from 'src/app/shared/models/security/user';
import { Authority } from 'src/app/shared/models/security/authority';

@Component({
	selector: 'app-nav-gestion-donnees',
	templateUrl: './nav-gestion-donnees.component.html',
	styleUrls: ['./nav-gestion-donnees.component.scss']
})
export class NavGestionDonneesComponent implements OnInit {
	tabs: any[];
	detailTab: any;

	@Input() addable = false;
	@Input() isDownloadable = false;
	@Input() isImportable = false;
	@Input() isExportable = false;
	@Output() importingEvent: EventEmitter<MouseEvent> =
		new EventEmitter<MouseEvent>();
	@Output() exportingEvent: EventEmitter<MouseEvent> =
		new EventEmitter<MouseEvent>();
	@Output() addEvent: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
	@Output() downloadLastSynthesisEvent: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

	user: User;

	constructor(private router: Router, private facade: FacadeService) {}

	ngOnInit(): void {
		this.user = this.facade.dataStorageService.getUser();

		const labelIntervention = this.facade.dataStorageService.getLabel(
			PARAM_LABEL_INTERVENTION
		);

		/**
		 * Elements de la navbar dans gestion des données
		 */
		this.tabs = [];

			this.tabs.push({
				name: 'Notifications',
				path: '/gestion/notificationEmail/list',
				parentPath: '/gestion/notificationEmail'
			});
			this.tabs.push({
				name: 'Rôles',
				path: '/gestion/roles/list',
				parentPath: '/gestion/roles'
			});
			this.tabs.push({
				name: 'Bons de commande',
				path: '/gestion/bonCommande/list',
				parentPath: '/gestion/bonCommande'
			});
			this.tabs.push({
				name: 'Utilisateurs',
				path: '/gestion/users/list',
				parentPath: '/gestion/users'
			});
			this.tabs.push({
				name: 'Intervenants',
				path: '/gestion/employees/list',
				parentPath: '/gestion/employees'
			});
			// this.tabs.push({
			// 	name: 'Employeurs',
			// 	path: '/gestion/employeurs/list',
			// 	parentPath: '/gestion/employeurs'
			// });
			this.tabs.push({
				name: 'Prescripteurs',
				path: '/gestion/prescripteurs/list',
				parentPath: '/gestion/prescripteurs'
			});
			this.tabs.push({
				name: 'Employeurs',
				path: '/gestion/employeurs/list',
				parentPath: '/gestion/employeurs'
			});
		//}
	}

	scrollTop() {
		window.scroll(0, 0);
	}

	userAsAnyAuthority(listAuthority: Authority[]) {
		return listAuthority.some((authority) => authority === this.user?.profile.id);
	}

	isRouterActive(path: string) {
		return this.router.isActive(path, false);
	}

	isRouterActiveForChild(path: string) {
		return this.router.isActive(path, false);
	}
}
